<template>
  <a-modal
    :visible="visible"
    :footer="null"
    :header="null"
    @cancel="closeModal"
    wrapClassName="act-now-chat-ai-modal"
  >
    <div class="act-now-chat-ai-modal-container">
      <div class="act-now-chat-ai-modal-container__header">
        <img
          src="@/assets/icons/glocal-ai-icon-navbar-black.svg"
          alt="Icon"
          class="act-now-chat-ai-modal-container__header--icon"
        />
        <h1 class="act-now-chat-ai-modal-container__header--title">
          Welcome to Glocal AI
        </h1>
      </div>
      <div class="act-now-chat-ai-modal-container__body">
        <h4>
          <p>Your Name</p>
          <p>[Your Address]</p>
          <p>[City, State ZIP Code]</p>
          <p>[Email Address]</p>
          <p>[Phone Number]</p>
          <p>[Date]</p>
          <p>The Honorable [Senator's Full Name]</p>
          <p>[Office Address of the Senator]</p>
          <p>[City, State ZIP Code]</p>

          <p>Dear Senator [Last Name],</p>

          <p>
            I am writing to you as a concerned resident of [your city/state] and
            a constituent in your district. I appreciate your service to our
            state and the work you do representing our interests in the U.S.
            Senate.
          </p>

          <p>
            I would like to express my concern regarding [briefly state the
            issue — e.g., climate change, student loan debt, healthcare, gun
            control, etc.]. This issue is of great importance to me because
            [briefly explain your personal connection or why it matters to you
            and your community].
          </p>

          <p>
            I respectfully urge you to [state the action you would like the
            senator to take — e.g., support or oppose a specific bill, allocate
            funding, push for hearings, etc.]. I believe this action is
            essential for the well-being of [your community, state, or the
            nation], and I hope you will consider the voices of your
            constituents when making decisions on this matter.
          </p>

          <p>
            Thank you for your time and for your continued service to our state.
            I would be grateful for a response to understand your position on
            this issue.
          </p>

          <p>Sincerely,</p>
          <p>[Your Full Name]</p>
        </h4>
        <div class="select-user-card">
          <p class="select-user-card__field"><span>Name: </span> Ashton Will</p>
          <p class="select-user-card__field">
            <span>Email: </span> ashton.will@senate.pk
          </p>
        </div>
      </div>
      <div class="act-now-chat-ai-modal-container__footer">
        <div class="act-now-chat-ai-modal-container__footer--comment">
          <img
            src="https://images.unsplash.com/photo-1633332755192-727a05c4013d?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D"
          />
          <textarea cols="30" placeholder="Submit inquiry..."></textarea>
          <div class="buttons">
            <a-button :loading="loading" class="btn">
              <i class="icon icon-send"></i>
            </a-button>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {};
  },
  methods: {
    closeModal() {
      this.$emit("handle-close", false);
    },
  },
};
</script>

<style lang="scss">
.act-now-chat-ai-modal {
  .ant-modal {
    width: 50rem !important;
    top: 8rem;

    .ant-modal-content {
      padding: 0;
      background-color: $color-white;

      .ant-modal-close {
        margin: 2rem 1.8rem 0 0;
      }

      .ant-modal-body {
        .act-now-chat-ai-modal-container {
          &__header {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            padding: 2.5rem;
            gap: 1rem;
            &--title {
              font-size: 2rem;
              font-family: $font-primary-bold;
              color: $color-black;
              margin-bottom: 0;
              line-height: normal;
            }
            &--icon {
              width: 4.5rem;
              height: auto;
            }
          }
          &__body {
            overflow-y: auto;
            max-height: calc(100vh - 40rem);
            padding: 0rem 2.5rem;
            h4 {
              font-size: 1.6rem;
              font-family: $font-primary;
              color: $color-black;
              margin-bottom: 0;
              line-height: normal;
              p {
                font-size: inherit;
                line-height: normal;
                margin-bottom: 1rem;
              }
            }
            .select-user-card {
              margin-top: 1.5rem;
              display: flex;
              flex-direction: column;
              gap: 0.5rem;
              &__field {
                font-size: 1.4rem;
                font-family: $font-primary;
                color: $color-black;
                margin-bottom: 0;
                line-height: normal;
                span {
                  font-family: $font-primary-medium;
                }
              }
            }
            &::-webkit-scrollbar {
              width: 0.4rem;
              height: 0.4rem;
            }

            &::-webkit-scrollbar-track {
              background-color: transparent;
              border-radius: 0.8rem;
            }

            &::-webkit-scrollbar-thumb {
              background-color: $color-primary;
              border-radius: 0.8rem;
            }
          }
          &__footer {
            width: calc(100% - 8rem);
            padding: 1.8rem 2rem;
            background-color: transparent;
            background-color: $color-white;
            width: 100%;
            border-end-start-radius: 2rem;
            border-end-end-radius: 2rem;
            &--comment {
              background-color: #eeeeee;
              padding: 0 1.4rem;
              border-radius: 1rem;
              display: flex;
              align-items: center;
              margin: 0 auto;
              img {
                width: 3rem;
                height: 3rem;
                border-radius: 100%;
                object-fit: fill;
              }
              textarea {
                padding: 0.8rem 1.5rem;
                margin: 0.5rem 0;
                border: none;
                font-size: 1.6rem;
                font-family: $font-primary;
                box-shadow: none;
                outline: none;
                line-height: 2.2rem;
                color: $color-black;
                background-color: transparent;
                resize: none;
                width: 100%;
                &::placeholder {
                  color: #868686;
                }
                &::-webkit-scrollbar {
                  display: none;
                }
              }
              .buttons {
                display: flex;
                align-items: center;
                .disabled {
                  opacity: 0.5;
                  cursor: not-allowed;
                }
                .ant-btn {
                  width: 5rem;
                  background-color: $color-primary;
                  border: none;
                  outline: none;
                  height: 3rem;
                  color: $color-white;
                  border-radius: 100px !important;
                  padding: 0 !important;
                  span {
                    line-height: normal;
                  }
                  .anticon {
                    .anticon-spin {
                      font-size: 1.5rem !important;
                      color: $color-primary;
                    }
                  }
                  &:hover,
                  &:focus {
                    background-color: $color-primary;
                    color: $color-white;
                  }
                  .icon {
                    font-size: 1.5rem;
                    display: block;
                    color: $color-white;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
